import { useMemo, useState } from 'react';

export const resetPersistState = (storeKey: string) => window.sessionStorage.removeItem(`persistState:${storeKey}`)

export const usePersistState = <Value>(
    storeKey: string,
    defaultValue: Value,
): [Value, (value: Value) => void] => {
    const initialValue = useMemo(() => {
        try {
            const valueFromCookie = window.sessionStorage.getItem(`persistState:${storeKey}`);
            return valueFromCookie ? JSON.parse(valueFromCookie) : defaultValue;
        } catch {
            window.sessionStorage.removeItem(`persistState:${storeKey}`);
            return defaultValue;
        }
    }, []);
    
    const [state, setState] = useState(initialValue);

    const changeState = (value: Value) => {
        window.sessionStorage.setItem(`persistState:${storeKey}`, JSON.stringify(value));
        setState(value);
    }

    return [state, changeState];
};